
export const navLinks = [
  {
    id: "about",
    title: "About",
  },
  {
    id: "work",
    title: "Work",
  },
  {
    id: "contact",
    title: "Contact",
  },
];

const services = [
  {
    title: "Web Developer",
    // icon: icon1,
  },
  {
    title: "React Native Developer",
    // icon: icon1,
  },
  {
    title: "Backend Developer",
    // icon: icon1,
  },
  {
    title: "Content Creator",
    // icon: icon1,
  },
];

const testimonials = [
  {
    testimonial:
      "Our overall experience during repairing of our 50/60 MVA Transformer was very good",
    name: "Shirish Tambey",
    designation: "GM",
    company: "Evonith Infrastructure",
    image: "https://res.cloudinary.com/ddy8u7ff2/image/upload/v1679774469/VishvasWebsite/Testimonials/xqi73yoghchrxcudyotv.jpg",
  },
  {
    testimonial:
      "Very Nice Factory for Transformers Manufacturing & Repairing.",
    name: "Purnendu Pradhan",
    designation: "",
    company: "Indian Railways",
    image: "",
  },
  {
    testimonial:
      "Vishvas Power Repaired Our 30 MVA Transformer in a record period of 25 days ",
    name: "Bhimrao Bagde",
    designation: "",
    company: "Asiatic Traders",
    image: "",
  },
];

const projects = [
  {
    name: "POH OF TRANSFORMERS",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam dapibus metus non ligula gravida, et iaculis risus placerat. Duis eu iaculis nisl, et rhoncus sem. Ut in suscipit tortor",
   
   
  },
  {
    name: "MANUFACTURING OF TRANSFORMER",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam dapibus metus non ligula gravida, et iaculis risus placerat. Duis eu iaculis nisl, et rhoncus sem. Ut in suscipit tortor",
    
   
  },
  {
    name: "REMANUFACTURING/ REPAIR OF TRANSFORMERS",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam dapibus metus non ligula gravida, et iaculis risus placerat. Duis eu iaculis nisl, et rhoncus sem. Ut in suscipit tortor",
  
    
   
  },
];

export { services, testimonials, projects };
